import React from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import EntryCamera from './Entry CameraLiveFeed/EntryCamera'
import DetectionStatistics from './DetectionStatistics/DetectionStatistics'
import RecentEntryDetections from './RecentEntryDetections/RecentEntryDetections'

function Entry_Camera_Monitor() {
  return (

   <Container fluid={true} className=''>
    <hr />

        {/* heading..................... */}
      <div className="">
        <h1 style={{ fontSize: "24px", color: "#1D67AA", fontWeight: "600" }}>
          Entry Camera Monitor
        </h1>
        <p style={{ color: "#535353", fontSize: "14px" }}>
          2025 - Week 26
        </p>
      </div>


      {/* ................Entry Camera Live Feed............. */}

      <Row>
        <Col md={8}>
        <EntryCamera />
        
        
        </Col>
        <Col>
        <DetectionStatistics/>
        
        
        </Col>
      </Row>

        {/* ................Recent Entry Detections............. */}
         
        <RecentEntryDetections/>
       

           
        




       </Container>
  )
}
export default Entry_Camera_Monitor